<template>
  <div class="multi-parcel-container">
    <!-- 批量操作工具栏：全选 + 批量图片上传 + 批量材质赋值 -->
    <div class="batch-toolbar">
      <!-- 全选图标 -->
      <md-icon
        name="check"
        size="lg"
        v-if="!isSelectAll"
        @click="handAll()"
        class="select-all-icon"
      />
      <md-icon
        name="checked"
        size="lg"
        v-else
        style="color: rgb(229, 28, 35)"
        @click="handCaKw()"
        class="select-all-icon"
      />

      <!-- 批量操作组：图片上传 + 材质赋值 -->
      <div class="batch-operation-group">
        <!-- 原有：批量上传图片 -->
        <div class="batch-item" style="position: relative">
          <md-image-reader
            name="batchReader"
            :is-camera-only="false"
            @select="onBatchReaderSelect"
            @complete="onBatchReaderComplete"
            @error="onBatchReaderError"
            :is-multiple="false"
            :amount="1"
            class="batch-upload-btn"
            :disabled="!hasSelectedParcel"
          ></md-image-reader>
          <span class="batch-text">批量传图</span>
          <!-- 批量图片上传反馈 -->
          <div class="batch-feedback">
            <img
              class="batch-preview-img"
              :src="batchPreviewUrl"
              alt="批量预览"
              v-if="batchPreviewUrl"
            >
            <span class="batch-loading" v-if="isBatchUploading">
              <md-icon name="loading" size="sm" color="#faad14"></md-icon> 上传中...
            </span>
          </div>
        </div>


        <!-- 新增：批量赋值材质 -->
        <div class="batch-item" v-if="addShow">
          <!-- 材质输入框：未选包裹禁用 -->
          <input
            type="text"
            v-model="batchMaterialValue"
            placeholder="输入材质"
            style="width: 3rem"
            class="batch-material-input"
            :disabled="!hasSelectedParcel"
            @keyup.enter="handleBatchMaterialAssign"
          >
          <!-- 确认赋值按钮：未选包裹禁用 -->
          <md-button
            type="primary"
            size="sm"
            style="width: 1.8rem;height: 0.6rem;font-size: 0.24rem"
            class="batch-material-btn"
            @click="handleBatchMaterialAssign"
            :disabled="!hasSelectedParcel || !batchMaterialValue"
          >
            批量赋材质
          </md-button>
          <!-- 材质赋值反馈 -->
          <span class="batch-success" v-if="isBatchMaterialSuccess">
            ✓ 材质赋值成功
          </span>
        </div>
      </div>
    </div>
    <div  class="batch-toolbar" style="text-align: left;color: #222222;font-weight: bold;margin-top: -0.2rem">
      <span style="font-size: 0.24rem">為了確保包裹能夠順利清關，加速海關審核申報資料請上傳一張購買截圖或訂單記錄(需包含商品品名、數量及金額）。👉 資訊僅在清關時使用，不會洩露給第三方，請放心。</span>
    </div>

    <!-- 包裹列表：保留原有选中逻辑 -->
    <div class="parcel-list">
      <div class="parcel-card" v-for="(parcel, index) in parcelList" :key="index">
        <div class="parcel-header" @click="checkall(index)">
          <md-icon name="check" size="lg" v-if="!parcel.isSelected" class="item-check-icon"/>
          <md-icon name="checked" size="lg" v-else style="color: rgb(229, 28, 35)" class="item-check-icon"/>
          <span class="express-number">{{ parcel.expressNumber }}</span>
          <span class="parcel-index">包裹{{ index + 1 }}</span>
        </div>

        <div class="parcel-product">
          <span class="product-label">包裹資訊：</span>
          <div class="product-tags">
            <div class="tag-item" v-for="(tag, tagIndex) in parcel.list" :key="tagIndex">
              {{ tag.name }} × {{ tag.num }}
            </div>
          </div>
        </div>

        <div class="parcel-info-row">
          <div class="material-input-wrap" v-if="addShow">
            <span class="material-label">材质：</span>
            <input
              v-model="parcel.parcelMaterial"
              placeholder="请输入包裹材质（如：纸箱）"
              class="material-input"
              @input="markModified(index)"
            >
          </div>


          <div class="image-upload-wrap">
            <ul class="image-reader-list">
              <li
                class="image-preview"
                v-if="parcel.imageList.length === 1"
                :style="{ backgroundImage: `url(${parcel.imageList[0]})` }"
              >
                <md-tag
                  class="image-delete-tag"
                  size="small"
                  shape="quarter"
                  fill-color="#ff4d4f"
                  type="fill"
                  font-color="#fff"
                  @click.native="onDeleteImage(index)"
                >
                  <md-icon name="close"></md-icon>
                </md-tag>
              </li>

              <li class="image-upload-btn" v-else>
                <md-image-reader
                  :name="'reader' + index"
                  :is-camera-only="false"
                  @select="onReaderSelect"
                  @complete="(name, data) => onReaderComplete(index, data)"
                  @error="(name, err) => onReaderError(index, err)"
                  :is-multiple="false"
                  :amount="1"
                ></md-image-reader>
                <md-icon name="camera" size="sm" color="#666"></md-icon>
                <span class="upload-text">上传图片</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部保存按钮 -->
    <div class="fixed-action-bar">
      <md-button
        type="warning"
        round
        class="batch-save-btn"
        @click="saveAll"
      >
        保存
      </md-button>
    </div>
  </div>
</template>

<script>
import {
  ImageReader,
  Button,
  Tag,
  Icon,
  Toast,
  Check,
  CheckGroup
} from "mand-mobile";

export default {
  name: "MultiParcelUploadMobile",
  components: {
    [ImageReader.name]: ImageReader,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Check.name]: Check,
    [CheckGroup.name]: CheckGroup,
  },
  data() {
    return {
      addShow: false,
      parcelList: [], // 所有包裹数据
      isSelectAll: false, // 全选状态
      // 批量图片上传相关状态（原有）
      batchPreviewUrl: "",
      isBatchUploading: false,
      isBatchSuccess: false,
      // 新增：批量材质赋值相关状态（与图片上传逻辑对齐）
      batchMaterialValue: "", // 批量材质输入值
      isBatchMaterialAssigning: false, // 材质赋值中
      isBatchMaterialSuccess: false // 材质赋值成功
    };
  },
  computed: {
    // 计算属性：是否有选中包裹（控制批量操作禁用状态）
    hasSelectedParcel() {
      return this.parcelList.some(parcel => parcel.isSelected);
    }
  },
  activated() {
    this.resetBatchStates();
    // 初始化包裹数据（添加选中状态）
    const routeParams = this.$route.query;
    if (parseInt(routeParams.type) === 1) {
      this.addShow = false
    } else {
      this.addShow = true
    }
    try {
      const parcelList = routeParams.parcelList ? JSON.parse(routeParams.parcelList) : [];
      if (parcelList.length) {
        this.parcelList = parcelList.map(val => ({
          ...val,
          isSelected: false,
          isModified: false,
          imageList: val.parcelImageUrl ? [val.parcelImageUrl] : []
        }));
      } else {
        this.showToast("未获取到包裹数据");
        setTimeout(() => history.back(), 1500);
      }
    } catch (err) {
      this.showToast("包裹数据解析失败");
      setTimeout(() => history.back(), 1500);
    }
  },
  methods: {
    // 重置所有批量操作状态
    resetBatchStates() {
      // 图片上传状态重置
      this.batchPreviewUrl = "";
      this.isBatchUploading = false;
      this.isBatchSuccess = false;
      // 材质赋值状态重置
      this.batchMaterialValue = "";
      this.isBatchMaterialAssigning = false;
      this.isBatchMaterialSuccess = false;
    },

    // 全选包裹
    handAll() {
      this.parcelList.forEach(val => {
        val.isSelected = true;
      });
      this.isSelectAll = true;
    },

    // 取消全选
    handCaKw() {
      this.parcelList.forEach(val => {
        val.isSelected = false;
      });
      this.isSelectAll = false;
      this.resetBatchStates(); // 取消全选时重置批量状态
    },

    showToast(content) {
      Toast.failed(content, 2000);
    },

    // 标记包裹修改
    markModified(index) {
      this.parcelList[index].isModified = true;
    },

    // 单个包裹选中/取消
    checkall(index) {
      this.parcelList[index].isSelected = !this.parcelList[index].isSelected;
      // 同步全选状态
      const hasUnselected = this.parcelList.some(val => !val.isSelected);
      this.isSelectAll = !hasUnselected;
      // 无选中包裹时重置批量状态
      if (!this.hasSelectedParcel) {
        this.resetBatchStates();
      }
    },

    // ---------------------- 原有：批量上传图片逻辑 ----------------------
    onBatchReaderSelect() {
      this.batchPreviewUrl = "";
      this.isBatchSuccess = false;
      Toast.loading("批量图片上传中...", 0);
    },

    onBatchReaderComplete(name, {dataUrl, file}) {
      Toast.hide();
      // 校验：未选包裹提示
      if (!this.hasSelectedParcel) {
        this.showToast("请选择包裹");
        return;
      }

      this.isBatchUploading = true;
      // 上传OSS获取正式URL
      const formData = new FormData();
      formData.append("file", file);
      this.http.APIASK(this.ports.qiniu, "post", formData)
        .then(res => {
          const batchImageUrl = res || "";
          if (!batchImageUrl) {
            this.onBatchReaderError({msg: "批量上传失败"});
            return;
          }

          // 赋值给所有选中包裹
          this.parcelList.forEach(val => {
            if (val.isSelected) {
              val.parcelImageUrl = batchImageUrl;
              val.imageList = [batchImageUrl];
              val.isModified = true; // 标记修改
            }
          });

          // 状态反馈
          this.batchPreviewUrl = dataUrl;
          this.isBatchUploading = false;
          this.isBatchSuccess = true;
          Toast.succeed(`批量传图成功，已赋值${this.getSelectedCount()}个包裹`, 2000);
        })
        .catch(() => {
          this.onBatchReaderError({msg: "网络异常，批量上传失败"});
        });
    },

    onBatchReaderError({msg}) {
      Toast.hide();
      this.isBatchUploading = false;
      this.isBatchSuccess = false;
      this.showToast(`批量传图：${msg}`);
    },

    // ---------------------- 新增：批量赋值材质逻辑（与图片上传对齐） ----------------------
    handleBatchMaterialAssign() {
      // 1. 基础校验
      const materialVal = this.batchMaterialValue;
      if (!materialVal) {
        this.showToast("请输入材质（如：纸箱）");
        return;
      }
      if (!this.hasSelectedParcel) {
        this.showToast("请选择包裹");
        return;
      }

      // 2. 标记赋值中状态
      this.isBatchMaterialAssigning = true;
      this.isBatchMaterialSuccess = false;

      // 3. 核心逻辑：赋值给所有选中包裹
      try {
        this.parcelList.forEach(val => {
          if (val.isSelected) {
            val.parcelMaterial = materialVal;
            val.isModified = true; // 标记修改（用于保存）
          }
        });

        // 4. 赋值成功反馈
        this.isBatchMaterialAssigning = false;
        this.isBatchMaterialSuccess = true;
        Toast.succeed(`材质赋值成功，已设置${this.getSelectedCount()}个包裹`, 2000);

        // 5. 3秒后重置状态（提升复用性）
        setTimeout(() => {
          this.batchMaterialValue = "";
          this.isBatchMaterialSuccess = false;
        }, 3000);
      } catch (err) {
        // 异常处理
        this.isBatchMaterialAssigning = false;
        this.showToast("材质赋值失败，请重试");
      }
    },

    // ---------------------- 原有：单个包裹图片操作 ----------------------
    onReaderSelect() {
      Toast.loading("图片上传中...", 0);
    },

    onReaderComplete(index, {dataUrl, file}) {
      Toast.hide();
      const parcel = this.parcelList[index];
      parcel.imageList = [dataUrl];
      parcel.isModified = true;

      const formData = new FormData();
      formData.append("file", file);
      this.http.APIASK(this.ports.qiniu, "post", formData)
        .then(res => {
          if (res) {
            parcel.parcelImageUrl = res;
            Toast.succeed(`包裹 ${index + 1} 图片上传成功`, 2000);
          } else {
            this.onReaderError(index, {msg: "图片上传失败"});
          }
        })
        .catch(() => {
          this.onReaderError(index, {msg: "网络异常"});
        });
    },

    onReaderError(index, {msg}) {
      Toast.hide();
      const parcel = this.parcelList[index];
      this.showToast(`包裹 ${index + 1}：${msg}`);
      parcel.imageList = parcel.parcelImageUrl ? [parcel.parcelImageUrl] : [];
    },

    onDeleteImage(index) {
      const parcel = this.parcelList[index];
      parcel.imageList = [];
      parcel.parcelImageUrl = "";
      parcel.isModified = true;
      this.showToast(`包裹 ${index + 1} 图片已删除`, 2000);
    },

    // ---------------------- 原有：校验与保存 ----------------------
    validateSingleParcel(parcel, index) {
      if (this.addShow) {
        if (!parcel.parcelMaterial) {
          return `包裹 ${index + 1}：请填写材质`;
        }
      }

      if (!parcel.parcelImageUrl) {
        return `包裹 ${index + 1}：请上传图片`;
      }
      return null;
    },

    saveAll() {
      const invalidMsgs = [];
      this.parcelList.forEach((parcel, index) => {
        const msg = this.validateSingleParcel(parcel, index);
        if (msg) invalidMsgs.push(msg);
      });

      if (invalidMsgs.length) {
        this.showToast(invalidMsgs.join("；"));
        return;
      }
      let list = []
      if (this.addShow) {
        list = this.parcelList.map(parcel => ({
          parcelMaterial: parcel.parcelMaterial,
          parcelImageUrl: parcel.parcelImageUrl,
          id: parcel.id
        }))
      } else {
        list = this.parcelList.map(parcel => ({
          parcelImageUrl: parcel.parcelImageUrl,
          id: parcel.id
        }))
      }
      Toast.loading("保存中...", 0);
      this.http.APIASK(this.ports.ParcelBatchUpdate, "post", {
        list
      }).then(res => {
        Toast.hide();
        if (res) {
          localStorage.setItem("parcelList", JSON.stringify(this.parcelList));
          Toast.succeed("保存成功", 2000);
          setTimeout(() => history.back(), 1000);
        }
      }).catch(() => {
        Toast.hide();
        this.showToast("网络异常，保存失败");
      });
    },

    // ---------------------- 工具方法：获取选中包裹数量 ----------------------
    getSelectedCount() {
      return this.parcelList.filter(parcel => parcel.isSelected).length;
    }
  }
};
</script>

<style lang="less" scoped>
/* 基础变量 */
@base-rem: 50px;
@primary-color: #faad14;
@gray-light: #f5f7fa;
@gray-mid: #e5e6eb;
@gray-dark: #666;
@red: #ff4d4f;
@success-color: #52c41a; /* 成功绿（与图片上传一致） */

/* 批量工具栏：适配移动端横向布局 */
.batch-toolbar {
  display: flex;
  align-items: center;
  padding: 0.15rem 0.2rem;
  margin-bottom: 0.2rem;
  background: #fff;
  border-radius: 0.16rem;
  box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.05);
  gap: 0.15rem; /* 全选图标与操作组间距 */
}

/* 全选图标：放大触控区域 */
.select-all-icon {
  cursor: pointer;
  --md-icon-size: 0.4rem; /* 适配移动端点击 */
}

/* 批量操作组：图片上传 + 材质赋值 横向排列 */
.batch-operation-group {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 0.15rem; /* 两个批量功能间距 */
  overflow-x: auto; /* 小屏可横向滚动 */
  padding-bottom: 0.05rem; /* 避免滚动条遮挡 */
}

/* 单个批量功能项：统一对齐 */
.batch-item {
  display: flex;
  align-items: center;
  gap: 0.1rem;
}

/* 批量功能文字：适配移动端大小 */
.batch-text {
  font-size: 0.24rem;
  color: @primary-color;
  white-space: nowrap; /* 避免文字换行 */
}

/* 批量反馈区域：统一样式（图片预览/加载/成功） */
.batch-feedback {
  display: flex;
  align-items: center;
  gap: 0.08rem;
  margin-left: 0.05rem;
}

/* 批量预览图：缩小尺寸（适配移动端） */
.batch-preview-img {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.08rem;
  border: 1px solid @gray-mid;
}

/* 批量加载/成功文本：统一大小和颜色 */
.batch-loading, .batch-success {
  font-size: 0.22rem;
  white-space: nowrap;
}

.batch-loading {
  color: @primary-color;
}

.batch-success {
  color: @success-color;
}

/* 新增：批量材质输入框（适配移动端） */
.batch-material-input {
  height: 0.65rem;
  font-size: 0.24rem;
  padding: 0 0.15rem;
  border: 1px solid @gray-mid;
  border-radius: 0.12rem;
  flex: 1;
  min-width: 1.2rem; /* 小屏最小宽度 */
  box-sizing: border-box;

  &::placeholder {
    color: @gray-dark;
    font-size: 0.22rem;
  }

  &:disabled {
    background: @gray-light;
    color: @gray-dark;
    cursor: not-allowed;
  }
}

/* 新增：批量材质按钮（适配移动端） */
.batch-material-btn {
  --md-button-height: 0.65rem;
  --md-button-font-size: 0.24rem;
  --md-button-padding: 0 0.2rem;
}

/* 包裹头部：调整选中图标位置 */
.parcel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  gap: 0.1rem; /* 选中图标与单号间距 */

  .express-number {
    font-size: 0.32rem;
    font-weight: 600;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    max-width: 70%; /* 防止单号过长溢出 */
  }

  .parcel-index {
    font-size: 0.3rem;
    font-weight: 500;
    color: @primary-color;
    background: @gray-light;
    padding: 0.05rem 0.15rem;
    border-radius: 0.15rem;
  }
}

/* 单个包裹选中图标：放大触控区域 */
.item-check-icon {
  --md-icon-size: 0.35rem;
  cursor: pointer;
}

/* 原有样式：保持不变 */
.multi-parcel-container {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 1.6rem;
  box-sizing: border-box;
  background: #fafafa;
  overflow-x: hidden;
}

.parcel-list {
  padding: 0.2rem;
}

.parcel-card {
  width: 100%;
  margin-bottom: 0.25rem;
  padding: 0.25rem;
  background: #fff;
  border-radius: 0.2rem;
  box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.parcel-product {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0.25rem;

  .product-label {
    font-size: 0.3rem;
    font-weight: 500;
    color: @gray-dark;
    margin-right: 0.15rem;
  }

  .product-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.12rem;

    .tag-item {
      font-size: 0.24rem;
      color: #555;
      background: @gray-light;
      padding: 0.08rem 0.16rem;
      border-radius: 0.18rem;
      border: 1px solid @gray-mid;
      white-space: nowrap;
    }
  }
}

.parcel-info-row {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-wrap: wrap;
}

.material-input-wrap {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 1.6rem;

  .material-label {
    font-size: 0.3rem;
    font-weight: 500;
    color: @gray-dark;
    margin-right: 0.15rem;
  }

  .material-input {
    flex: 1;
    height: 0.7rem;
    font-size: 0.26rem;
    color: #333;
    padding: 0 0.18rem;
    border: 1px solid @gray-mid;
    border-radius: 0.12rem;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: @primary-color;
      box-shadow: 0 0 0 0.03rem rgba(250, 173, 20, 0.2);
    }

    &::placeholder {
      color: #aaa;
      font-size: 0.24rem;
    }
  }
}

.image-upload-wrap {
  display: flex;
  align-items: center;

  .image-reader-list {
    display: flex;
    align-items: center;
    gap: 0.15rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .image-preview {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 0.12rem;
    background-size: cover;
    background-position: center;
    border: 1px solid @gray-mid;
    box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.05);
    position: relative;
  }

  .image-delete-tag {
    position: absolute;
    top: -0.08rem;
    right: -0.08rem;
    opacity: 0.9;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }

    .md-icon {
      font-size: 0.24rem;
    }
  }

  .image-upload-btn {
    width: 1.6rem;
    height: 1.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: @gray-light;
    border: 1px dashed @gray-mid;
    border-radius: 0.12rem;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    &:hover {
      background: #f0f2f5;
      border-color: @primary-color;
    }

    .md-icon {
      font-size: 0.38rem;
      color: @gray-dark;
      margin-bottom: 0.08rem;
    }

    .upload-text {
      font-size: 0.22rem;
      color: @gray-dark;
    }
  }
}

.fixed-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.2rem;
  background: #fff;
  box-shadow: 0 -0.03rem 0.15rem rgba(0, 0, 0, 0.05);
  box-sizing: border-box;

  .batch-save-btn {
    width: 100%;
    height: 0.8rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #fff;
    background: @primary-color;
    border-radius: 0.15rem;
    transition: all 0.2s;

    &:hover {
      background: #f79f1f;
      transform: scale(1.02);
    }

    &:disabled {
      background: #ffd8a6;
      transform: none;
    }
  }
}

:deep(.md-toast__content) {
  font-size: 0.26rem !important;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  padding: 0.18rem 0.28rem !important;
  border-radius: 0.15rem !important;
  bottom: 2rem !important;
  box-shadow: 0 0.05rem 0.15rem rgba(0, 0, 0, 0.1);
}

/* 适配小屏：避免横向溢出 */
@media (max-width: 375px) {
  .batch-operation-group {
    gap: 0.1rem;
  }

  .batch-text {
    font-size: 0.22rem;
  }

  .batch-material-input {
    font-size: 0.22rem;
  }
}
</style>
